import Api from './api';

const updateTranslationRequest = (translation) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/translations/' + translation.id , translation, { headers: { Authorization: 'Bearer ' + access_token } })
}

const placeTranslationRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/translations/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const getTranslationRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/translations/' + id, { headers: { Authorization: 'Bearer ' + access_token } })
}

export default { updateTranslationRequest, placeTranslationRequest, getTranslationRequest }



// WEBPACK FOOTER //
// ./src/api/apiTranslations.js